module.exports = __webpack_public_path__ + "img/13800.bc811e58.jpg";